import { PublishedWorkDetailsStrings } from './PublishedWorkDetailsStrings';
import { PublishedWorkEditStrings } from './PublishedWorkEditStrings';

export const PublishedWorkStrings = {
  details: PublishedWorkDetailsStrings,
  edit: PublishedWorkEditStrings
};
